import { normalizeEin } from "./ein";

/** Browser-safe registry metadata and identifier normalization. */
export const registryNames = {
  propublica: "ProPublica",
  acnc: "Australian Charities and Not-for-profits Commission (ACNC)",
} as const;

export function supportsOrganizationLookup(countryCode: string): boolean {
  return ["US", "AU"].includes(countryCode.trim().toUpperCase());
}

/** Format validation only, not proof of registration. */
export function normalizeOrganizationId(
  countryCode: string,
  input: string,
): string | null {
  switch (countryCode.trim().toUpperCase()) {
    case "US":
      return normalizeEin(input);

    case "AU": {
      const value = input.trim();
      return /^(?:\d{11}|\d{2} \d{3} \d{3} \d{3})$/.test(value)
        ? value.replaceAll(" ", "")
        : null;
    }

    default:
      return null;
  }
}

/** The ACNC publishes its register through this public CKAN DataStore API. */
export function australianCharityRecordUrl(abn: string): string {
  const url = new URL("https://data.gov.au/data/api/3/action/datastore_search");
  url.searchParams.set("resource_id", "eb1e6be4-5b13-4feb-b28e-388bf7c26f93");
  url.searchParams.set("filters", JSON.stringify({ ABN: abn }));
  url.searchParams.set("limit", "2");
  return url.href;
}
